import * as Yup from "yup";

export const PersonalSchema = {
  first_time_applicant: Yup.boolean().required(
    "Membership Status is required."
  ),
  membership_type: Yup.string()
    .required("The membership type field is required.")
    .oneOf(
      [
        "Life",
        "Contributing",
        "Sustaining",
        "Corporate",
        "Associate - College",
        "Associate - Senior High School",
        "Associate - Junior High School",
        "Associate - Elementary",
      ],
      "Invalid Input"
    ),
  last_name: Yup.string().trim().required("The last name field is required."),
  first_name: Yup.string().trim().required("The first name field is required."),
  middle_name: Yup.string()
    .trim()
    .required("The middle name field is required."),
  sex: Yup.string()
    .required("The gender field is required")
    .oneOf(
      ["Male", "Female", "Non-binary", "Prefer not to say"],
      "Invalid Input"
    ),
  birthdate: Yup.date().required("The birthdate field is required"),
  contact_no: Yup.number()
    .required("The contact number field is required")
    .test(
      "phl_contactNo",
      "Please check the length of the contact number",
      (value) => {
        const regex = /^\d{10}$/;
        return regex.test(value);
      }
    ),
  email: Yup.string()
    .email("Email must be valid")
    .trim()
    .required("The email field is required"),
  facebook: Yup.string().trim().optional().nullable(),
  profession: Yup.string()
    .trim()
    .required("The profession / occupation field is required"),
  school_office: Yup.string().trim().optional().nullable(),
  school_office_address: Yup.string().trim().optional().nullable(),
  block_no: Yup.string().trim().optional().nullable(),
  street_name: Yup.string().trim().optional().nullable(),
  subdivision: Yup.string().trim().optional().nullable(),
  province: Yup.string().required("The province field is required"),
  city: Yup.string().required("The city field is required"),
  barangay: Yup.string().optional().nullable(),
  payment_method: Yup.string()
    .required("The payment method field is required")
    .oneOf(["Bank Transfer", "GCash", "Cash", "Others"], "Invalid Input"),
  proof_of_payment: Yup.mixed()
    .nullable()
    .when("payment_method", {
      is: (value) => value !== "Cash",
      then: Yup.mixed().required("The proof of payment field is required"),
      otherwise: Yup.mixed().notRequired(),
    }),
  contribution: Yup.string().required("The contribution field is required"),
  acknowledgement: Yup.boolean()
    .required("Please acknowledge the Data Privacy Act of 2012")
    .oneOf([true], "Please acknowledge the Data Privacy Act of 2012"),
  honorifics: Yup.string().trim().required("Salutation is required"),
  others_honorifics: Yup.string()
    .trim()
    .when("honorifics", {
      is: "Others",
      then: Yup.string()
        .trim()
        .required("The other salutation field is required"),
      otherwise: Yup.string().trim().notRequired(),
    }),
};

export const PersonalMembershipSchema = Yup.object({
  ...PersonalSchema,
});
export const LifeMembershipSchema = Yup.object({
  ...PersonalSchema,
  signature: Yup.object().required("The signature field is required"),
  life_membership_delivery: Yup.string()
    .required("Life Membership ID Delivery is required")
    .oneOf(["Pick-up from PMHA Office", "Delivery via LBC"], "Invalid Input"),
  delivery_address: Yup.string()
    .trim()
    .optional()
    .when("life_membership_delivery", {
      is: "Delivery via LBC",
      then: Yup.string().trim().required("Delivery Address is required"),
    })
    .nullable(),
});
export const ServerLifeMembershipSchema = Yup.object({
  ...PersonalSchema,
  signature: Yup.object().optional().nullable(),
  proof_of_payment: Yup.object().optional().nullable(),
});

export const OrganizationSchema = {
  first_time_applicant: Yup.boolean().required(
    "Membership Status is required."
  ),
  membership_type: Yup.string()
    .required("The membership type field is required.")
    .oneOf(
      [
        "Life",
        "Contributing",
        "Sustaining",
        "Corporate",
        "Associate - College",
        "Associate - Senior High School",
        "Associate - Junior High School",
        "Associate - Elementary",
      ],
      "Invalid Input"
    ),
  name_of_org: Yup.string()
    .trim()
    .required("The name of organization field is required."),
  contact_no: Yup.number()
    .required("The  contact number field is required")
    .test(
      "phl_contactNo",
      "Please check the length of the contact number",
      (value) => {
        const regex = /^\d{10}$/;
        return regex.test(value);
      }
    ),
  email: Yup.string()
    .email("Email must be valid")
    .trim()
    .required("The email field is required"),
  socials: Yup.string()
    // .matches(
    //     /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    //     'Enter valid URL'
    // ).optional(),
    .optional()
    .nullable(),
  point_person: Yup.string()
    .trim()
    .required("The point person field is required."),
  block_no: Yup.string().trim().optional().nullable(),
  street_name: Yup.string().trim().optional().nullable(),
  subdivision: Yup.string().trim().optional().nullable(),
  province: Yup.string().required("The province field is required"),
  city: Yup.string().required("The city field is required"),
  barangay: Yup.string().optional().nullable(),
  payment_method: Yup.string()
    .required("The payment method field is required")
    .oneOf(["Bank Transfer", "GCash", "Cash", "Others"], "Invalid Input"),
  proof_of_payment: Yup.mixed()
    .nullable()
    .when("payment_method", {
      is: (value) => value !== "Cash",
      then: Yup.mixed().required("The proof of payment field is required"),
      otherwise: Yup.mixed().notRequired(),
    }),
  contribution: Yup.string().required("The contribution field is required"),
  honorifics: Yup.string().trim().required("Salutation is required"),
  others_honorifics: Yup.string()
    .trim()
    .when("honorifics", {
      is: "Others",
      then: Yup.string()
        .trim()
        .required("The other salutation field is required"),
      otherwise: Yup.string().trim().notRequired(),
    }),
  acknowledgement: Yup.boolean()
    .required("Please acknowledge the Data Privacy Act of 2012")
    .oneOf([true], "Please acknowledge the Data Privacy Act of 2012"),
};

export const OrganizationMembershipSchema = Yup.object({
  ...OrganizationSchema,
});

export const MembershipSchema = Yup.lazy((values) => {
  if (
    values.membership_type === "Corporate" ||
    values.membership_type === "Sustaining"
  ) {
    if (values.isVolunteer) {
      return OrganizationMembershipSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return OrganizationMembershipSchema;
  } else if (values.membership_type === "Life") {
    if (values.isVolunteer) {
      return LifeMembershipSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return LifeMembershipSchema;
  } else {
    if (values.isVolunteer) {
      return PersonalMembershipSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return PersonalMembershipSchema;
  }
});

export const ServerOrganizationSchema = Yup.object({
  ...OrganizationSchema,
  proof_of_payment: Yup.mixed().notRequired(),
});

export const ServerPersonSchema = Yup.object({
  ...PersonalSchema,
  proof_of_payment: Yup.object().optional().nullable(),
  signature: Yup.object().optional().nullable(),
});

export const ServerMembershipSchema = Yup.lazy((values) => {
  if (
    values.membership_type === "Corporate" ||
    values.membership_type === "Sustaining"
  ) {
    if (values.isVolunteer) {
      return ServerOrganizationSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return ServerOrganizationSchema;
  } else if (values.membership_type === "Life") {
    if (values.isVolunteer) {
      return ServerLifeMembershipSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return ServerLifeMembershipSchema;
  } else {
    if (values.isVolunteer) {
      return ServerPersonSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return ServerPersonSchema;
  }
});

export const MembershipDetailsModalSchema = Yup.object({
  status: Yup.string()
    .required("The status field is required")
    .oneOf(
      [
        "For Confirmation",
        "Verified",
        "Replied",
        "Processing Certificate",
        "Completed",
      ],
      "Invalid Input"
    ),
  payment_status: Yup.string()
    .required("The payment status field is required")
    .oneOf(["Pending", "Verified"], "Invalid Input"),
  contribution: Yup.number()
    .required("The contribution field is required")
    .min(0.0, "Contribution must be greater than 0"),
});

// admin or dms schema
export const AdminPersonSchema = Yup.object({
  ...PersonalSchema,
  proof_of_payment: Yup.object().optional().nullable(),
  signature: Yup.object().optional().nullable(),
  membership_date: Yup.date().required("The membership date field is required"),
});

export const AdminOrganizationSchema = Yup.object({
  ...OrganizationSchema,
  proof_of_payment: Yup.object().optional().nullable(),
  membership_date: Yup.date().required("The membership date field is required"),
});

export const AdminLifeMembershipSchema = Yup.object({
  ...PersonalSchema,
  signature: Yup.object().optional().nullable(),
  proof_of_payment: Yup.object().optional().nullable(),
  membership_date: Yup.date().required("The membership date field is required"),
});

export const AdminMembershipSchema = Yup.lazy((values) => {
  if (
    values.membership_type === "Corporate" ||
    values.membership_type === "Sustaining"
  ) {
    if (values.isVolunteer) {
      return AdminOrganizationSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return AdminOrganizationSchema;
  } else if (values.membership_type === "Life") {
    if (values.isVolunteer) {
      return AdminLifeMembershipSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return AdminLifeMembershipSchema;
  } else {
    if (values.isVolunteer) {
      return AdminPersonSchema.omit([
        "payment_method",
        "proof_of_payment",
        "contribution",
      ]).shape({
        contribution: Yup.string()
          .required("The contribution field is required")
          .default("₱0.00"),
      });
    }
    return AdminPersonSchema;
  }
});

export default MembershipSchema;
